module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Applications_02-a531ac4d4bd98b654f2614e577f86611.jpg";